import React, { useContext } from 'react'
import { Form, Image, Label, Input } from 'semantic-ui-react'
import * as R from 'ramda'
import styled from 'styled-components'

import { QuestionBuilderContext } from 'organisms/QuestionBuilderCard'
import ImageRatingButtonList from 'components/NewQuestion/ImageRatingButtonList'

const DEFAULT_ICON_SET_IMAGE_URL = 'https://cdn.simplesat.io/images/missing-icon-set-thumbnail.png'

const PreviewChoiceInput = styled(Input)`
  &:not(:first-child) {
    margin-top: 0.5em;
  }
`

export default function StarQuestionInput() {
  const { handleFieldChange, question, dispatch, iconSetId, defaultIconSetId, iconSetOptions } =
    useContext(QuestionBuilderContext)

  const starIconSets = iconSetOptions.filter((icon) => icon.metric === '5-STAR')
  const minScoreIcon = R.propOr(
    DEFAULT_ICON_SET_IMAGE_URL,
    'choice_value_1',
    question.choiceIconSet
  )
  const maxScoreIcon = R.propOr(
    DEFAULT_ICON_SET_IMAGE_URL,
    'choice_value_5',
    question.choiceIconSet
  )

  return (
    <React.Fragment>
      <Form.Group>
        <Form.Field>
          <label>Icon set</label>
          <ImageRatingButtonList
            iconSetId={iconSetId || defaultIconSetId}
            onClick={(iconSet) => {
              dispatch({ type: 'SET_ICON_SET', iconSet })
              handleFieldChange('choiceIconSet', () => iconSet)()
            }}
            iconSetOptions={starIconSets}
            defaultPreviewIconSetImageKey="choice_value_5"
          />
        </Form.Field>
      </Form.Group>
      <Form.Group widths="equal" className="field">
        <Form.Field>
          <label>Min score</label>
          <PreviewChoiceInput
            className="large labeled"
            label={
              <Label basic style={{ padding: 8 }}>
                <Image className="use this style" src={minScoreIcon} alt="negative" />
              </Label>
            }
            value={question.leftSideLabel}
            onChange={handleFieldChange('leftSideLabel')}
            maxLength={250}
            required
          />
        </Form.Field>
        <Form.Field>
          <label>Max score</label>
          <PreviewChoiceInput
            className="large labeled"
            label={
              <Label basic style={{ padding: 8 }}>
                <Image className="use this style" src={maxScoreIcon} alt="positive" />
              </Label>
            }
            value={question.rightSideLabel}
            onChange={handleFieldChange('rightSideLabel')}
            maxLength={250}
            required
          />
        </Form.Field>
      </Form.Group>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/StarQuestionInput/index.js